module.exports = __webpack_public_path__ + "00bb8353ed6a16095f6abb8adbd2c0b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fiserv_2022_chart.png
// module id = 1676
// module chunks = 0